<template>
  <div class="fts-users" @scroll="onScroll">
    <div class="fts-client-header" :class="{ scrolled: scroll }">
      <div class="client-header-center">
        <font-awesome-icon
          :icon="['fas', 'user-friends']"
          fixed-width
          size="lg"
          class="client-header-icon"
        />
        <div class="client-header-title">Users</div>
      </div>
    </div>
    <div class="user-body">
      <div class="user-action-bar">
        <div class="user-action-l">
          <input
            type="text"
            class="fts-form-control user-search-control"
            placeholder="Search by User"
            v-model="searchDisplayName"
            @input="search"
          />

          <!-- <fts-btn
            color="primary"
            outline
            boxShadowNone
            class="mb-1 fts-capitalize fts-font-normal"
            @click="openUserModal"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />New
          </fts-btn> -->

          <fts-btn
            color="primary"
            outline
            boxShadowNone
            class="mb-1 fts-capitalize fts-font-normal"
            @click="openInvitation"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />Invite
          </fts-btn>
        </div>
        <div class="user-action-r">
          <fts-btn outline textTransformInit @click="getMember">
            <font-awesome-icon :icon="['fas', 'sync-alt']" />
            Refresh
          </fts-btn>
        </div>
      </div>
      <!-- not found -->
      <fts-result-not-found
        :show="!loading && users && users.length === 0"
        :search="onSearch"
        :error="error && !onSearch && !loading"
        :creatable="false"
        @create="openUserModal"
      />

      <div class="user-container">
        <div
          class="user-wrapper"
          v-for="(user, index) in users"
          :key="`${user.userProfileId}-${index}`"
        >
          <div class="user-upr-row">
            <!-- avatar -->
            <div class="user-avatar">
              <fts-profile
                :profile="{
                  displayName: user.displayName,
                  profilePictureUrl: user.profilePictureUrl,
                }"
                :profilePhotoSize="48"
                :profileName="false"
              />
            </div>
            <!-- user info -->
            <div class="user-info fts-row gutters">
              <div class="fts-col fts-col-md-8">
                <div class="user-info-wrapper">
                  <fts-tippy
                    trigger-class="user-info-name"
                    :content="user.displayName"
                    class="user-info-name-wrapper"
                    @click.native.prevent="openUserModal(user)"
                  >
                    <template #trigger>{{user.displayName}}</template>
                  </fts-tippy>
                  <div class="user-roles">
                    <fts-tippy
                      class="user-role-wrapper"
                      trigger-class="user-role"
                      content="Owner"
                      v-if="user.owner"
                    >
                      <template #trigger>Owner</template>
                    </fts-tippy>
                    <fts-tippy
                      class="user-role-wrapper"
                      trigger-class="user-role"
                      :content="consultant.label"
                      v-if="user.consultant"
                    >
                      <template #trigger>{{consultant.label}}</template>
                    </fts-tippy>
                    <fts-tippy
                      class="user-role-wrapper"
                      trigger-class="user-role"
                      :content="workspaceAdmin.label"
                      v-if="user.workspaceAdmin"
                    >
                      <template #trigger>{{workspaceAdmin.label}}</template>
                    </fts-tippy>
                    <fts-tippy
                      class="user-role-wrapper"
                      trigger-class="user-role"
                      :content="userAdmin.label"
                      v-if="user.userAdmin"
                    >
                      <template #trigger>{{userAdmin.label}}</template>
                    </fts-tippy>
                  </div>
                </div>
                <div class="user-info-username">
                  {{user.userName}}
                </div>
              </div>
              <div class="fts-col fts-col-md-4" v-if="user.phoneNumber">
                <div class="user-info-phone">
                  <font-awesome-icon
                    :icon="['fas', 'phone-alt']"
                    fixed-width
                    class="user-info-phone-icon"
                  />
                  <div class="user-info-phone-number">{{user.phoneNumber}}</div>
                </div>
              </div>
            </div>
            <!-- actions -->
            <div class="user-actions">
              <div class="user-status">
                <div class="user-status-wrapper" :class="user.status">
                  {{ user.status }}
                </div>
                <font-awesome-icon
                  :icon="['fas', 'lock']"
                  class="user-status-locked"
                  v-if="user.isLocked"
                />
              </div>
              <fts-dropdown-select
                class="user-action-dropdown"
                append-content-class="user-action-content user-action-dropdown-menu"
                :offset="[0, 6]"
                placement="left-start"
                @selected="executeAction($event, user)">
                <fts-btn slot="toggle" icon text class="user-action-toggle">
                  <font-awesome-icon :icon="['fas', 'ellipsis-v']" />
                </fts-btn>
                <template #menu="{ select, defaultOptionClass }">
                  <!-- reset password -->
                  <div
                    class="user-action-option"
                    :class="defaultOptionClass"
                    @click="select('resetPassword')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'key']"
                      fixed-wdith
                      class="user-action-option-icon"
                    />
                    <div class="user-action-option-r">
                      <div class="user-action-option-label">Reset Password</div>
                      <div class="user-action-option-helper">
                        Request to reset a new password.
                      </div>
                    </div>
                  </div>
                  <!-- enable member -->
                  <div
                    class="user-action-option"
                    :class="defaultOptionClass"
                    @click="select('disable')"
                    v-if="user.disabled"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'user-check']"
                      fixed-width
                      class="user-action-option-icon"
                    />
                    <div class="user-action-option-r">
                      <div class="user-action-option-label">Enable Member</div>
                      <div class="user-action-option-helper">
                        Cannot change workspace settings or invite new members
                        to the workspace.
                      </div>
                    </div>
                  </div>
                  <!-- disable member -->
                  <div
                    class="user-action-option"
                    :class="defaultOptionClass"
                    @click="select('disable')"
                    v-else
                  >
                    <font-awesome-icon
                      :icon="['fas', 'user-times']"
                      fixed-width
                      class="user-action-option-icon"
                    />
                    <div class="user-action-option-r">
                      <div class="user-action-option-label">Disable Member</div>
                      <div class="user-action-option-helper">
                        Cannot change workspace settings or invite new members
                        to the workspace.
                      </div>
                    </div>
                  </div>
                  <!-- unlock user -->
                  <div
                    class="user-action-option"
                    :class="defaultOptionClass"
                    @click="select('lock')"
                    v-if="user.isLocked"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'unlock']"
                      fixed-width
                      class="user-action-option-icon"
                    />
                    <div class="user-action-option-r">
                      <div class="user-action-option-label">Unlock User</div>
                      <div class="user-action-option-helper">
                        Activate the user to access the workspace.
                      </div>
                    </div>
                  </div>
                  <!-- consultant -->
                  <template v-if="isAdministrator">
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('consultant')"
                      v-if="!user.consultant"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-check']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Set as {{consultant.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{consultant.description}}
                        </div>
                      </div>
                    </div>
                    <!-- remove workspace admin -->
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('consultant')"
                      v-else
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-times']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Remove {{consultant.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{consultant.description}}
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- workspace admin -->
                  <template v-if="isAdminUser">             
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('workspaceAdmin')"
                      v-if="!user.workspaceAdmin"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-check']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Set as {{workspaceAdmin.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{workspaceAdmin.description}}
                        </div>
                      </div>
                    </div>
                    <!-- remove workspace admin -->
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('workspaceAdmin')"
                      v-else
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-times']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Remove {{workspaceAdmin.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{workspaceAdmin.description}}
                        </div>
                      </div>
                    </div>
                  </template>
                  <!-- user admin -->
                  <template v-if="isAdminUser || isManagerUser">
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('userAdmin')"
                      v-if="!user.userAdmin"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-check']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Set as {{userAdmin.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{userAdmin.description}}
                        </div>
                      </div>
                    </div>
                    <!-- remove user admin -->
                    <div
                      class="user-action-option"
                      :class="defaultOptionClass"
                      @click="select('userAdmin')"
                      v-else
                    >
                      <font-awesome-icon
                        :icon="['fas', 'user-times']"
                        fixed-width
                        class="user-action-option-icon"
                      />
                      <div class="user-action-option-r">
                        <div class="user-action-option-label">
                          Remove {{userAdmin.label}}
                        </div>
                        <div class="user-action-option-helper">
                          {{userAdmin.description}}
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </fts-dropdown-select>
            </div>
          </div>
          <!-- user profile -->
          <div class="user-profile-section" v-if="!user.isExternalUser">
            <div class="user-profile-container">
              <fts-btn
                sm
                outline
                textTransformInit
                :color="x.active ? 'success' : 'danger'"
                v-for="x in getUserProfiles(user.profiles)"
                :key="x.id"
                @click="
                  openQuickView({
                    locusId: x.entryId,
                    moduleId: x.id,
                    user: user,
                  })
                "
              >
                <font-awesome-icon
                  :icon="['fas', 'circle']"
                  class="user-profile-state"
                />
                <fts-moji :emoji="x.emoji" :size="16" v-if="x.emoji" />
                <span class="user-profile-name">{{ x.name }}</span>
                <font-awesome-icon
                  :icon="['far', 'trash-alt']"
                  class="user-profile-action stopPropagation"
                  @click="
                    deleteUserProfile({
                      locusId: x.entryId,
                      moduleId: x.id,
                      user: user,
                    })
                  "
                />
              </fts-btn>
              <fts-dropdown-select
                append-content-class="profile-content profile-dropdown-menu"
                @selected="openQuickView({ moduleId: $event.id, user: user })"
                v-if="getAvailableUserProfiles(user.profiles).length">
                <fts-btn
                  slot="toggle"
                  text
                  sm
                  textTransformInit
                  boxShadowNone
                  color="#9e9e9e"
                >
                  <font-awesome-icon :icon="['fas', 'plus']" />
                  <span class="profile-toggle-label">create profile</span>
                </fts-btn>
                <template #menu="{ select, defaultOptionClass }">
                  <div
                    class="profile-option"
                    :class="defaultOptionClass"
                    v-for="x in getAvailableUserProfiles(user.profiles)"
                    :key="x.id"
                    @click="select(x)"
                  >
                    <fts-moji
                      :emoji="x.emoji"
                      :size="16"
                      class="profile-option-emoji"
                      v-if="x.emoji"
                    />
                    <div class="profile-option-name">{{ x.name }}</div>
                  </div>
                </template>
              </fts-dropdown-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- reset password modal -->
    <fts-client-modal
      title="Request Reset Password"
      @closed="resetModal"
      ref="resetPasswordModal"
    >
      <!-- header:icon -->
      <font-awesome-icon slot="icon" :icon="['fas', 'key']" fixed-width />
      <!-- body -->
      <template #body>
        <!-- temporary password -->
        <template v-if="modalFormData.temporaryPassword">
          <div class="confirmation-desc">
            Temporary password for {{ modalFormData.userName }} is:
          </div>
          <div class="confirmation-clipboard-form-control">
            <div class="confirmation-clipboard-copy">
              {{modalFormData.temporaryPassword}}
              <div class="confirmation-clipboard-copy-hint" v-if="temporaryPasswordCopied">Copied</div>
            </div>
            <fts-btn
              icon
              text
              v-clipboard:copy="modalFormData.temporaryPassword"
              v-clipboard:success="onCopyTemporaryPassword"
            >
              <font-awesome-icon :icon="['far', 'clone']" />
            </fts-btn>
          </div>
        </template>
        <!-- request -->
        <template v-else>
          <div class="confirmation-desc">
            This will replace {{ modalFormData.userName }}'s current password with
            a new password.
          </div>
          <fts-btn
            color="primary"
            outline
            text-transform-init
            :loading="modalLoading"
            class="confirmation-action"
            @click="resetPassword"
          >
            Request New Password
          </fts-btn>
        </template>
      </template>
      <!-- footerRight -->
      <template #footerRight>
        <fts-btn
          text
          :disabled="modalLoading"
          @click="closeResetPasswordModal"
        >
          <font-awesome-icon :icon="['fas', 'times']" /> Close
        </fts-btn>
      </template>
    </fts-client-modal>
    <!-- user unlock modal -->
    <fts-client-modal
      title="Unlock user account"
      @closed="resetModal"
      ref="userUnlockModal"
    >
      <!-- header:icon -->
      <font-awesome-icon slot="icon" :icon="['fas', 'unlock']" fixed-width />
      <!-- body -->
      <template #body>
        <div class="confirmation-desc">
          It will allow {{ modalFormData.userName }} access to this workspace.
        </div>
      </template>
      <!-- footerRight -->
      <template #footerRight>
        <fts-btn
          text
          :disabled="modalLoading"
          @click="closeUserUnlockModal"
        >
          <font-awesome-icon :icon="['fas', 'times']" /> Close
        </fts-btn>

        <fts-btn
          color="primary" 
          :loading="modalLoading" 
          @click="unlock"
        >
          <font-awesome-icon :icon="['fas', 'unlock']" /> Unlock
        </fts-btn>
      </template>
    </fts-client-modal>
    <!-- user access modal -->
    <fts-client-modal
      :title="modalFormData.disabled ? 'Enable user for access?' : 'Disable user for access?'"
      @closed="resetModal"
      ref="userAccessModal"
    >
      <!-- header:icon -->
      <font-awesome-icon slot="icon" :icon="['fas', 'user-check']" fixed-width v-if="modalFormData.disabled" />
      <font-awesome-icon slot="icon" :icon="['fas', 'user-times']" fixed-width v-else />
      <!-- body -->
      <template #body>
        <template v-if="modalFormData.disabled">
          <div class="confirmation-desc">
            It will allow {{ modalFormData.userName }} access to this workspace.
          </div>
          <div class="confirmation-subtext">
            You can block access by disable the member later.
          </div>
        </template>

        <template v-else>
          <div class="confirmation-desc">
            It will block {{ modalFormData.userName }}'s access to this
            workspace.
          </div>
          <div class="confirmation-subtext">
            You can restore access by enable the member later.
          </div>
        </template>
      </template>
      <!-- footerRight -->
      <template #footerRight>
        <fts-btn
          text
          :disabled="modalLoading"
          @click="closeUserAccessModal"
        >
          <font-awesome-icon :icon="['fas', 'times']" /> Close
        </fts-btn>

        <fts-btn
          color="primary"
          :loading="modalLoading"
          @click="setDisableEnable"
        >
          <template v-if="modalFormData.disabled">
            <font-awesome-icon :icon="['fas', 'user-check']" /> Enable
          </template>
          <template v-else>
            <font-awesome-icon :icon="['fas', 'user-times']" /> Disable
          </template>
        </fts-btn>
      </template>
    </fts-client-modal>
    <!-- user modal -->
    <fts-client-modal
      :title="`${userId ? 'Update': 'Create' } User`"
      @closed="resetUserModal"
      ref="userModal"
    >
      <!-- header:icon -->
      <font-awesome-icon slot="icon" :icon="['far', 'user']" fixed-width />
      <!-- body -->
      <template #body>
        <template v-for="x in fields">
          <fts-form-element
            :item="x"
            :form-data="userModalFormData"
            :validator="$v.userModalFormData"
            comfort-design
            :key="x.id"
          />
        </template>
      </template>
      <!-- footer:right -->
      <template #footerRight>
        <fts-btn
          text
          :disabled="modalLoading"
          @click="closeUserModal"
        >
          <font-awesome-icon :icon="['fas', 'times']" /> Close
        </fts-btn>

        <fts-btn
          color="primary"
          :loading="modalLoading"
          @click.native.prevent="updateMember"
          v-if="userId"
        >
          <font-awesome-icon :icon="['fas', 'check']" /> {{userId ? 'Update': 'Create'}}
        </fts-btn>
      </template>
    </fts-client-modal>
    <!-- spinner -->
    <fts-spinner :show="loading" fullScreen />
    <!--todo: getMember-->
    <!-- invitation -->
    <fts-invitation ref="ftsInvitation" />
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import commons from "../commons/commons";
import { passwordValidator } from "../commons/validator";
import { authorizationStore } from "../store/authorizationStore";
import { clientStore } from "../store/clientStore";

import FTSClientModal from "../elements/FTSClientModal";
import FTSProfile from "../elements/FTSProfile";
import FTSBtn from "../elements/FTSBtn";
import FTSTippy from "../elements/FTSTippy";
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSFormElement from "../elements/FTSFormElement";
import FTSSpinner from "../elements/FTSSpinner";
import FTSResultNotFound from "../elements/error/FTSResultNotFound";
import FTSMoji from "../elements/FTSMoji";
import FTSInvitation from "./FTSInvitation";

export default {
  data: () => ({
    scroll: false,
    users: [],
    searchDisplayName: "",
    loading: false,
    error: false,
    onSearch: false,
    /* modal */
    modalLoading: false,
    modalFormData: {},
    /* temporary password */
    temporaryPasswordCopied: false,
    /* user modal */
    userModalFormData: {},
    /* user roles */
    consultant: {
      label: 'Consultant',
      description: 'Can access studio, change workspace settings and invite new members to the workspace.'
    },
    workspaceAdmin: {
      label: 'Workspace Admin',
      description: 'Can access studio, change workspace settings and invite new members to the workspace.'
    },
    userAdmin: {
      label: 'User Admin',
      description: 'Can invite new members to the workspace.'
    },
  }),
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-profile": FTSProfile,
    "fts-btn": FTSBtn,
    "fts-tippy": FTSTippy,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-form-element": FTSFormElement,
    "fts-spinner": FTSSpinner,
    "fts-result-not-found": FTSResultNotFound,
    "fts-moji": FTSMoji,
    "fts-invitation": FTSInvitation,
  },
  validations() {
    let userModalFormData = {};
    userModalFormData = commons.getFormValidators(this.fields);
    return { userModalFormData };
  },
  methods: {
    onScroll(e) {
      this.scroll = e.target.scrollTop > 0;
    },
    search: _.debounce(async function () {
      await this.getMember();
      this.onSearch = this.searchDisplayName ? true : false;
    }, 500),
    getUserRoles(roles) {
      try {
        return roles.join(",");
      } catch (err) {
        console.error(err);
      }
    },
    getUserProfiles(profiles) {
      return this.moduleProfile.reduce((list, x) => {
        const userProfile = profiles.find((y) => y.moduleId == x.id);
        if (userProfile) {
          list.push({
            id: x.id,
            name: x.name,
            emoji: x.emoji,
            entryId: userProfile.entryId,
            active: userProfile.active,
          });
        }
        return list;
      }, []);
    },
    getAvailableUserProfiles(profiles) {
      return this.moduleProfile.reduce((list, x) => {
        const userProfile = profiles.find((y) => y.moduleId == x.id);
        if (!userProfile) {
          list.push({
            id: x.id,
            name: x.name,
            emoji: x.emoji,
          });
        }
        return list;
      }, []);
    },
    async executeAction(type, selectedItem) {
      if (
        type == "workspaceAdmin" ||
        type == "userAdmin" ||
        type == "consultant"
      ) {
        try {
          await clientStore.dispatch("setRole", {
            userProfileId: selectedItem.userProfileId,
            workspaceAdmin:
              type == "workspaceAdmin"
                ? !selectedItem.workspaceAdmin
                : selectedItem.workspaceAdmin,
            userAdmin:
              type == "userAdmin"
                ? !selectedItem.userAdmin
                : selectedItem.userAdmin,
            consultant:
              type == "consultant"
                ? !selectedItem.consultant
                : selectedItem.consultant,
          });
          await this.getMember();
          this.$toasted.success(`User role have been updated`);
        } catch (err) {
          this.$toasted.global.error({
            response: err.response,
            message: "Failed to update user role",
          });
        }
      } else if (type == "resetPassword") {
        this.modalFormData = _.clone(selectedItem);
        this.$refs.resetPasswordModal.show();
      } else if (type == "lock") {
        this.modalFormData = _.clone(selectedItem);
        this.$refs.userUnlockModal.show();
      } else if (type == "disable") {
        this.modalFormData = _.clone(selectedItem);
        this.$refs.userAccessModal.show();
      }
    },
    closeResetPasswordModal() {
      this.$refs.resetPasswordModal.close();
    },
    closeUserUnlockModal() {
      this.$refs.userUnlockModal.close();
    },
    closeUserAccessModal() {
      this.$refs.userAccessModal.close();
    },
    resetModal() {
      this.modalFormData = {};
    },
    /* user modal */
    openUserModal(user) {
      this.$refs.userModal.show();
      this.userModalFormData = user && user.userProfileId ? _.clone(user) : {};
    },
    closeUserModal() {
      this.$refs.userModal.close();
    },
    resetUserModal() {
      this.userModalFormData = {};
      this.$v.userModalFormData.$reset();
    },
    openQuickView(data) {
      if (commons.elementStopPropagation()) return;

      if (data.moduleId && data.locusId) {
        window.eventBus.$emit("quickViewData", {
          username: data.user.userName,
          items: [{ id: data.locusId }],
        });
      } else if (data.moduleId) {
        window.eventBus.$emit("quickViewData", {
          activityId: "create",
          username: data.user.userName,
          vectorId: data.moduleId,
        });
      }
    },
    deleteUserProfile(data) {
      if (data.moduleId && data.locusId) {
        window.eventBus.$emit("quickViewData", {
          username: data.user.userName,
          activityId: "delete",
          items: [{ id: data.locusId }],
        });
      }
    },
    openInvitation() {
      this.$refs.ftsInvitation.open();
    },
    onCopyTemporaryPassword() {
      if (!this.temporaryPasswordCopied) {
        this.temporaryPasswordCopied = true;
        setTimeout(() => {
          this.temporaryPasswordCopied = false;
        }, 2000);
      }
    },
    async getMember() {
      this.loading = true;
      this.error = false;
      try {
        let res = await clientStore.dispatch("getMember", {
          searchDisplayName: this.searchDisplayName,
        });
        this.users = res.data.map((x) => ({
          ...x,
          status: x.disabled ? "inactive" : "active",
        }));
      } catch (err) {
        this.users = [];
        this.error = true;
        this.$toasted.error("Failed to retrieve users");
      }
      this.loading = false;
    },
    async memberRegistration() {
      this.$v.userModalFormData.$touch();
      if (this.$v.userModalFormData.$invalid) {
        return this.$toasted.global.invalidFormValidate();
      } else {
        this.modalLoading = true;
        let customError = false;
        const formData = Object.assign({}, this.userModalFormData);
        try {
          let res = await clientStore.dispatch("memberRegistration", formData);
          if (res.data.result.succeeded) {
            await this.getMember();
            this.$toasted.success("Successfully created");
            this.closeUserModal();
          } else {
            customError = true;
            throw res.data.result.errors;
          }
        } catch (err) {
          customError
            ? this.$toasted.error(err)
            : this.$toasted.error(`Failed to create`);
        }
        this.modalLoading = false;
      }
    },
    async updateMember() {
      this.$v.userModalFormData.$touch();
      if (this.$v.userModalFormData.$invalid) {
        return this.$toasted.global.invalidFormValidate();
      } else {
        this.modalLoading = true;
        const formData = Object.assign({}, this.userModalFormData);
        try {
          await clientStore.dispatch("updateMember", {
            ...formData,
            id: formData.userProfileId,
          });
          await this.getMember();
          this.$toasted.success("Successfully updated");
        } catch (err) {
          this.$toasted.error(`Failed to update`);
        }

        this.closeUserModal();
        this.modalLoading = false;
      }
    },
    async resetPassword() {
      this.modalLoading = true;
      try {
        let res = await clientStore.dispatch("resetUserPassword", {
          id: this.modalFormData.userProfileId,
        });
        this.modalFormData.temporaryPassword = res.data.password;
        this.$toasted.success("Password reset successfully");
      } catch (err) {
        this.$toasted.global.error({
          response: err.response,
          message: "Failed to reset password",
        });
        this.closeResetPasswordModal();
      }
      this.modalLoading = false;
    },
    async setDisableEnable() {
      this.modalLoading = true;
      try {
        await clientStore.dispatch("setDisableEnable", {
          id: this.modalFormData.userProfileId,
        });
        await this.getMember();
        this.$toasted.success(
          `User access has been ${
            this.modalFormData.disabled ? "granted" : "denied"
          }`
        );
      } catch (err) {
        this.$toasted.global.error({
          response: err.response,
          message: "Failed to update user access",
        });
      }
      this.closeUserAccessModal();
      this.modalLoading = false;
    },
    async unlock() {
      this.modalLoading = true;
      try {
        await clientStore.dispatch("unlockUser", {
          id: this.modalFormData.userProfileId,
        });
        await this.getMember();
        this.$toasted.success(
          `User access has been ${
            this.modalFormData.isLocked ? "unlock" : "locked"
          }`
        );
      } catch (err) {
        this.$toasted.global.error({
          response: err.response,
          message: "Failed to update user access",
        });
      }
      this.closeUserUnlockModal();
      this.modalLoading = false;
    },
  },
  computed: {
    fields() {
      return [
        {
          type: 0,
          fieldName: "userName",
          required: !this.userId,
          readOnly: this.userId,
        },
        {
          input: "password",
          fieldName: "password",
          required: true,
          visible: !this.userId,
          validator: {
            password: passwordValidator,
          },
        },
        {
          type: 0,
          fieldName: "displayName",
          required: !this.userId,
        },
        {
          type: 0,
          fieldName: "firstName",
          readOnly: this.userId,
        },
        {
          type: 0,
          fieldName: "lastName",
          readOnly: this.userId,
        },
        {
          type: 26,
          fieldName: "phoneNumber",
        },
        {
          type: 25,
          fieldName: "email",
        },
      ].filter((x) => x.visible != false);
    },
    workspaceId() {
      return clientStore.getters.workspaceId;
    },
    moduleProfile() {
      return clientStore.state.workspaceModules.filter((x) => x.isProfile);
    },
    userId() {
      return this.userModalFormData && this.userModalFormData.userProfileId;
    },
    isAdministrator() {
      return authorizationStore.getters.isAdministrator;
    },
    isAdminUser() {
      return authorizationStore.getters.isAdminUser;
    },
    isManagerUser() {
      return authorizationStore.getters.isManagerUser;
    },
  },
  beforeMount() {
    if (!(authorizationStore.getters.isAdminUser || authorizationStore.getters.isManagerUser)) {
      this.$toasted.error("Access Denied. Please refer to your system administrator.");
      this.$router.push({ name: 'dashboard' });
    }
  },
  async mounted() {
    await this.getMember();
    window.eventBus.$on("quickViewRefresh", async () => {
      await this.getMember();
    });
  },
  beforeDestroy() {
    window.eventBus.$off("quickViewRefresh");
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-users {
  height: 100%;
  overflow: auto;
  color: var(--fts-text);
  .user-search-control {
    max-width: 200px;
    font-size: 0.875rem;
    border-radius: 0.25rem;
  }
  .user-body {
    min-width: 768px;
    .user-action-bar {
      display: flex;
      align-items: center;
      padding: 0 1rem;
      .user-action-l {
        @include flex-gap($gap: 0.375rem, $wrap: nowrap);
        align-items: center;
      }
      .user-action-r {
        @include flex-gap($gap: 0.375rem, $wrap: nowrap);
        align-items: center;
        justify-content: flex-end;
      }
    }
    .user-container {
      max-width: 992px;
      margin: 2rem auto;
      .user-wrapper {
        min-width: 0;
        display: flex;
        flex-direction: column;
        margin: 0 1rem;
        padding: 1rem;
        border-top: 1px solid var(--fts-gray-3);
        &:last-child {
          border-bottom: 1px solid var(--fts-gray-3);
        }
        &:hover {
          background: rgba($color: $primaryColor, $alpha: 0.095);
          .user-info-name {
            color: $primaryColor;
          }
        }
        .user-upr-row {
          display: flex;
          align-items: flex-start;
        }
        .user-avatar {
          margin-right: 1rem;
        }
        .user-info {
          flex: 1;
          min-width: 0;
          @include flex-gap($display: flex, $gapTop: .75rem);
          .user-info-wrapper {
            display: flex;
            align-items: center;
          }
          .user-info-name-wrapper {
            min-width: 0;
            cursor: pointer;
            .user-info-name {
              @include text-overflow-ellipsis;
            }
          }
          .user-info-username {
            @include text-overflow-ellipsis;
            margin-top: .275rem;
            font-size: 0.875rem;
            font-weight: 300;
            color: var(--fts-gray-5);
          }
          .user-info-phone {
            display: flex;
            align-items: center;
            .user-info-phone-icon {
              margin-right: 0.575rem;
              font-size: 0.75rem;
              color: var(--fts-gray-5);
            }
            .user-info-phone-number {
              @include text-overflow-ellipsis;
              font-size: 0.875rem;
            }
          }
          .user-roles {
            display: flex;
            min-width: 0;
            margin-left: .375rem;
            .user-role-wrapper {
              min-width: 0;
              cursor: default;
              &:not(:first-child) {
                margin-left: 0.375rem;
              }
              .user-role {
                @include theme() {
                  background: rgba(theme-get('fts-gray-5'), 0.195);
                }
                @include text-overflow-ellipsis;
                padding: 0.175rem 0.375rem;
                font-size: 0.675rem;
                border-radius: 0.25rem;
                color: var(--fts-gray-5);
              }
            }
          }
        }
        .user-actions {
          min-width: 150px;
          display: flex;
          align-items: center;
          padding-left: 1rem;
          .user-status {
            display: flex;
            align-items: center;
            flex: 1;
            .user-status-wrapper {
              padding: 0.375rem;
              border-radius: 0.25rem;
              text-transform: capitalize;
              font-size: 0.875rem;
              cursor: default;
              &.active {
                @include theme() {
                  background: rgba($color: theme-get('fts-success'), $alpha: 0.05);
                }
                color: var(--fts-success);
              }
              &.inactive {
                @include theme() {
                  background: rgba($color: theme-get('fts-danger'), $alpha: 0.05);
                }
                color: var(--fts-danger);
              }
            }
            .user-status-locked {
              @include theme() {
                color: darken(theme-get('fts-danger'), 5%);
              }
              margin-left: 0.75rem;
              font-size: 0.75rem;
            }
          }
        }
        .user-profile-section {
          margin-top: 1rem;
          flex: 1 1 100%;
          .user-profile-container {
            @include flex-gap($gap: 0.575rem);
            .user-profile-name {
              font-weight: 400;
              color: var(--fts-text);
            }
            .user-profile-state {
              margin-right: 0.575rem;
              font-size: 0.575rem;
            }
            .user-profile-action {
              margin-left: 0.375rem;
              margin-right: 0;
              &:hover {
                color: var(--fts-text);
              }
              &:not(:hover) {
                color: var(--fts-gray-5);
              }
            }
          }
        }
      }
    }
  }
  // dropdown menu
  .user-action-dropdown {
    margin-left: 1.5rem;
    .user-action-toggle {
      font-size: 0.875rem;
    }
  }
  .profile-toggle-label {
    font-weight: 400;
  }
  /* confirmation modal */
  .confirmation-desc {
    font-size: 1rem;
    line-height: 1.5;
  }
  .confirmation-subtext {
    font-size: 0.875rem;
    color: var(--fts-gray-5);
    line-height: 1.5;
  }
  .confirmation-action {
    margin-top: .375rem;
  }
  /* confirmation clipboard */
  .confirmation-clipboard-form-control {
    display: flex;
    align-items: center;
    margin-top: .375rem;
    padding: .375rem .75rem;
    border-radius: .375rem;
    background: var(--fts-gray-1);
    .confirmation-clipboard-copy {
      position: relative;
      flex: 1;
      margin-right: .375rem;
      font-size: .75rem;
      word-break: break-all;
      color: var(--fts-gray-5);
    }
    .confirmation-clipboard-copy-hint {
      @include absolute-center-y;
      right: 0;
      padding: .375rem;
      box-shadow: var(--fts-elevation-3);
      border-radius: .25rem;
      background: var(--fts-popover-background);
      color: var(--fts-text);
      font-size: .75rem;
    }
  }
}
/* user action dropdown menu */
.user-action-content.user-action-dropdown-menu {
  .user-action-option {
    display: flex;
    align-items: flex-start;
    padding: 0.575rem 1rem;
    font-size: 0.875rem;
    .user-action-option-icon {
      margin-right: 0.575rem;
      color: var(--fts-gray-5);
    }
    .user-action-option-r {
      .user-action-option-label {
        line-height: 1.35;
      }
      .user-action-option-helper {
        margin-top: 0.175rem;
        font-size: 0.75rem;
        color: var(--fts-gray-5);
        line-height: 1.25;
      }
    }
  }
}
/* profile dropdown menu */
.profile-content.profile-dropdown-menu {
  min-width: 200px;
  max-width: 200px;
  .profile-option {
    display: flex;
    align-items: center;
    .profile-option-emoji {
      margin-right: 0.375rem;
    }
    .profile-option-name {
      @include text-overflow-hidden;
    }
  }
}
/* popover user role */
.popover-user-role-label {
  font-size: .875rem;
  line-height: 1.5;
}
.popover-user-role-description {
  margin-top: .175rem;
  font-size: .75rem;
  line-height: 1.25;
  opacity: .75;
}
</style>